import useContent from '../stores/useContent';
import { callOmnitrack } from './callOmnitrack';
import SCORM, { getCompleted, getFirm, setCompleted } from './SCORM';

function deepSearch(object, key, predicate) {
  /* eslint-disable */
  if (object.hasOwnProperty(key) && predicate(key, object[key]) === true)
    return object;

  for (let i = 0; i < Object.keys(object).length; i++) {
    let value = object[Object.keys(object)[i]];
    if (typeof value === 'object' && value != null) {
      let o = deepSearch(object[Object.keys(object)[i]], key, predicate);
      if (o != null) return o;
    }
  }

  return null;
  /* eslint-enable */
}

const findInContentById = (content: unknown, id: string) => {
  return deepSearch(content, 'id', (k, v) => v === id);
};

window.submitOmnitrackIntegrations = submitOmnitrackIntegrations;

export default async function submitOmnitrackIntegrations() {
  const content = useContent().compiled;
  const { omnitrack } = content;

  if (!omnitrack) {
    return;
  }

  const { endpoint, base } = omnitrack.config;
  const tenantId = omnitrack.config.tenantId[getFirm()];
  const suspend = window.app.suspend;

  for (const form of Object.values(omnitrack.forms)) {
    const { formId } = form;

    if (getCompleted('submittedOmnitrack ' + formId)) {
      continue;
    }

    const u = {};

    u[form.name] = SCORM.fullName;
    u[form.email] = SCORM.userName;
    u[form.date] = Date.now();

    Object.entries(form.fields).forEach(([cId, oIdAndType]) => {
      try {
        const [oId, oType] = oIdAndType.split(/\s+/);

        if (oType === 'yes_no' || oType === 'drop_down') {
          const q = findInContentById(content.pages, cId);
          // NOTE: only takes first selected option

          const selectedOption = suspend.questionOptions?.[cId]?.[0];
          const optionIndex = selectedOption.match(/o\d+$/)?.[0]?.slice(1);
          const optionText = Object.values(q.options[optionIndex])[0]?.trim();

          if (oType === 'yes_no' && ['Yes', 'No', 'N/A'].includes(optionText)) {
            u[oId] = optionText;
          } else if (oType === 'drop_down') {
            u[oId] = optionText;
          }
        }

        if (oType === 'long_text') {
          u[oId] = suspend.inputs[cId];
        }
      } catch (e) {
        console.warn(e);
      }
    });

    const sId = await callOmnitrack({
      formId,
      base,
      endpoint,
      tenantId,
      endUserInput: u
    });

    if (sId) {
      setCompleted('submittedOmnitrack ' + formId);
    }
  }
}
